import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["form"]

  reset(event) {
    event.preventDefault()
    
    // Reset all checkboxes
    this.formTarget.querySelectorAll('input[type="checkbox"]').forEach(checkbox => {
      checkbox.checked = false
    })

    // Reset all text inputs and dates
    this.formTarget.querySelectorAll('input[type="text"], input[type="date"]').forEach(input => {
      input.value = ''
    })

    // Reset select elements
    this.formTarget.querySelectorAll('select').forEach(select => {
      select.value = ''
    })
  }

  submit() {
    this.formTarget.requestSubmit()
  }
}
